export default {
    MENU_ITEM_TITLE_HEIGHT: 70,
    MENU_ITEM_LINK_HEIGHT: 56,
    LINK_HEIGHT: 70,
    LINK_WITH_MENU_PADDING_BOTTOM: 26,
    LINK_ITEM_TRANSITION_DURATION: 300
};
